import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import Welcome from './Pages/Welcome';
import Login from './Pages/Login';
import Signup from './Pages/Signup';
import ForgotPassword from './Pages/ForgotPassword';
import ResetPassword from './Pages/ResetPassword';
import Home from './Pages/Home';
import Players from './Pages/Players';
import PlayerProfile from './Pages/PlayerProfile';
import Profile from './Pages/Profile';
import Clans from './Pages/Clans';
import UserAbout from './Pages/UserAbout';
import UserSettings from './Pages/UserSettings';
import Following from './Pages/Following';
import Followers from './Pages/Followers';
import Help from './Pages/Help';
import PersonalInfo from './Pages/PersonalInfo';
import UserPrivacy from './Pages/UserPrivacy';
import UserTerms from './Pages/UserTerms';
import AuthCallback from './Pages/AuthCallback';

// Wrapper for protected routes (active users only)
const Protected = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

// Wrapper for onboarding route (onboarding or active users)
const Onboarding = ({ children }) => (
  <ProtectedRoute allowOnboarding={true}>{children}</ProtectedRoute>
);

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Welcome />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth-callback" element={<AuthCallback />} />

      {/* Onboarding route - allows onboarding status */}
      <Route path="/personal-info" element={<Onboarding><PersonalInfo /></Onboarding>} />

      {/* Protected routes - active users only */}
      <Route path="/home" element={<Protected><Home /></Protected>} />
      <Route path="/players" element={<Protected><Players /></Protected>} />
      <Route path="/players/:id" element={<Protected><PlayerProfile /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/clans" element={<Protected><Clans /></Protected>} />
      <Route path="/about" element={<Protected><UserAbout /></Protected>} />
      <Route path="/settings" element={<Protected><UserSettings /></Protected>} />
      <Route path="/following" element={<Protected><Following /></Protected>} />
      <Route path="/followers" element={<Protected><Followers /></Protected>} />
      <Route path="/help" element={<Protected><Help /></Protected>} />
      <Route path="/privacy" element={<Protected><UserPrivacy /></Protected>} />
      <Route path="/terms" element={<Protected><UserTerms /></Protected>} />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;